export default "__VITE_ASSET__CV_mzkm2__"